import React, { Component } from 'react';
import {Switch} from "../buttons/Swtich";
import BudgetPartialGoalRows from "./BudgetPartialGoal";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {HELP_BUDGET_PARTIAL_GOALS, LinkToArticle} from "../help_center/LinkToArticle";
import { withTranslation } from 'react-i18next';

export const ALLOCATED_AMOUNT_GOAL = "ALLOCATED_AMOUNT_GOAL";
export const PERCENTAGE_GOAL = "PERCENTAGE_GOAL";

class BudgetPartialGoalsConfigurationClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enabled: this.props.enabled,
            budgetPartialGoals: this.props.budgetPartialGoals,
            includedInAgencySubscription: null
        };

        this.handleBudgetPartialGoalsChange = this.handleBudgetPartialGoalsChange.bind(this);
        this.handleEnabledChange = this.handleEnabledChange.bind(this);
    }

    componentDidMount() {
        this.fetchIncludedInAgencySubscription();
    }

    agencySubscriptionURL() {
        return API_URL + 'agency/subscription/';
    }

    fetchIncludedInAgencySubscription() {
        new APIClient(this.agencySubscriptionURL()).call('GET').then((data) => {
            if (data.status === 'ERROR_NO_AGENCY' || data.status === 'ERROR') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                this.setState({
                    includedInAgencySubscription: data.data.budget_partial_goals_enabled
                });
            }
        })
    }

    handleBudgetPartialGoalsChange(budgetPartialGoals) {
        this.setState({...this.state, budgetPartialGoals: budgetPartialGoals}, ()=> { this.sendNewChangesToParentComponent()});
    }

    sendNewChangesToParentComponent() {
        this.props.onChange(this.state.budgetPartialGoals);
    }

    handleEnabledChange(event) {
        const enabled = event.target.checked;
        if(!enabled)
            this.setState({budgetPartialGoals: [], enabled: false}, ()=> { this.sendNewChangesToParentComponent()});
        else
            this.setState({...this.state, enabled: true}, ()=> { this.sendNewChangesToParentComponent()});
    }

    renderPartialRows() {
        if (!this.state.enabled)
            return null;

        if (this.state.includedInAgencySubscription === null)
            return <div className="box-loader"><Spinner color="positive"/></div>;

        if (!this.state.includedInAgencySubscription)
            return this.renderNoInSubscriptionMessage();

        return <div className="row g-3">
            <BudgetPartialGoalRows budgetTotalAmount={this.props.budgetTotalAmount}
                                   budgetPeriodType={this.props.budgetPeriodType}
                                   budgetFromDate={this.props.budgetFromDate} budgetToDate={this.props.budgetToDate}
                                   budgetPartialGoals={this.state.budgetPartialGoals}
                                   onChange={this.handleBudgetPartialGoalsChange}/>
        </div>
    }

    renderNoInSubscriptionMessage() {
        const { t } = this.props;
        return <div className="alert alert-info" style={{margin:"0.6em 1.5em 0.6em 2.6em"}}>
                {t('budget_partial_goals_config.subscription_message')}
        </div>;
    }

    render() {
        const { t } = this.props;
        return (
            <div className={this.props.className || ''} style={{ marginTop: '20px' }}>
                <div className="form-row switch-input -horizontal" style={{ borderBottom: "0", marginBottom: "0", position: "relative", zIndex: 2, justifyContent: 'flex-start', padding: 0 }}>
                    <Switch style={{marginLeft: "0"}} onChange={this.handleEnabledChange} checked={this.state.enabled} name="enabled"/>
                    <label style={{paddingLeft:"10px", position: "relative", backgroundColor: "white", padding: "0 0px", marginLeft: "10px"}}>
                        {t('budget_partial_goals_config.want_define_investment_segments')} <LinkToArticle article={HELP_BUDGET_PARTIAL_GOALS}/>
                    </label>
                </div>
                {this.state.enabled && (
                    <div className="radio-box-border">
                        {this.renderPartialRows()}
                    </div>
                )}
            </div>
        );
    }
}

export const BudgetPartialGoalsConfiguration = withTranslation()(BudgetPartialGoalsConfigurationClass);
export default BudgetPartialGoalsConfiguration;
